import {AppController} from "../../../core/app/app-controller";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {EntityDescriptionDomainService} from "../../../domain/entity-description/services/entity-description.domain-service";
import {EntityDescriptionRequestParams} from "../../../domain/entity-description/models/entity-description.request-params";
import type {EntityDescriptionDataSource} from "../../../domain/entity-description/models/entity-description.data-source";
import {MetadataManager} from "../../../core/managers/metadata.manager";
import {NEW_GAME_CENTER_CONTAINER} from "../game-center-container.consts";
import type {GameCenterContainerState} from "../models/game-center-container.state";
import {ENTITY_DESCRIPTION} from "../../../modules/entity-description-module/entity-description.module.consts";

export class GameCenterContainerMetadataFetchHandler extends FetchHandler {
  controller: AppController;
  state: GameCenterContainerState
  type = NEW_GAME_CENTER_CONTAINER.ACTION_TYPES.fetchMetadata

  static injectables = [EntityDescriptionDomainService, MetadataManager];

  constructor(service: EntityDescriptionDomainService, metadataManager: MetadataManager) {
    super(service);

    this.metadataManager = metadataManager
  }

  get requestParams() {
    const prefix = this.metadataManager.terminatorPrefix;
    const apiType = this.metadataManager.apiType;
    const entityId: Number = this.state.game.id;
    const sportType: Number = this.state.sportTypeId;
    const sectionNames: String = this.metadataManager.sectionNames;
    const entityType: Number = this.state.game.isScheduled ? ENTITY_DESCRIPTION.ENTITY_TYPE.preMatch : ENTITY_DESCRIPTION.ENTITY_TYPE.postMatch;

    const requestParams: EntityDescriptionRequestParams = new EntityDescriptionRequestParams(prefix, apiType, entityId, entityType, sportType, sectionNames, false);

    return requestParams;
  }

  async action() {
    const dataSource: EntityDescriptionDataSource = await super.fetch()

    this.metadataManager.updateSections(dataSource?.sections);

    return dataSource
  }
}
